import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { DateTime } from 'luxon';
import { BaseBusyableComponent } from '../../Services/BaseBusyableComponent';
import { ConfigService } from "../../Services/ConfigService";
import { ScheduleItemService } from '../../Services/Custom/ServiceScheduleItem';
import { Guid } from 'guid-typescript';

@Component({
	selector: 'ScheduleEdit',
	templateUrl: 'ScheduleEdit.html',
    
})
export class ScheduleEditComponent extends BaseBusyableComponent implements OnInit {

	ngOnInit() {
		this.isSmallScreen = window.innerWidth <= 992;
		this.sizeEmitter.subscribe(width => {
			this.isSmallScreen = width <= 992;
		})
	}
	sizeEmitter = new EventEmitter<number>();
	@HostListener('window:resize', ['$event'])
	onResize(event: any) {
		this.sizeEmitter.next(window.innerWidth);
	}


	isSmallScreen = false;

	@Output() newClicked = new EventEmitter<any>();

	newBtnClicked() {
		this.newClicked.emit({});
	}

	@Input() Title = 'Schedule';
	@Input() showTime = true;
	@Input() isWarehouse = false;
	@Input() showMaxOrders = false;
	@Input() newIsBlankDays = false;
	@Input() newIsBlankTime = false;
	@Input() showNewBtn: boolean = false;
	addSchedule() {
		this.myService.getNewSchedule()
			.subscribe(newSched => {
				if (this.newIsBlankDays) {
					newSched.RepeatOnSunday = false;
					newSched.RepeatOnMonday = false;
					newSched.RepeatOnTuesday = false;
					newSched.RepeatOnWednesday = false;
					newSched.RepeatOnThursday = false;
					newSched.RepeatOnFriday = false;
					newSched.RepeatOnSaturday = false;
				} else {
					var SunSelected = this.items.filter(s => s.RepeatOnSunday).length > 0;
					var MonSelected = this.items.filter(s => s.RepeatOnMonday).length > 0;
					var TueSelected = this.items.filter(s => s.RepeatOnTuesday).length > 0;
					var WedSelected = this.items.filter(s => s.RepeatOnWednesday).length > 0;
					var ThuSelected = this.items.filter(s => s.RepeatOnThursday).length > 0;
					var FriSelected = this.items.filter(s => s.RepeatOnFriday).length > 0;
					var SatSelected = this.items.filter(s => s.RepeatOnSaturday).length > 0;

					newSched.RepeatOnSunday = !SunSelected;
					newSched.RepeatOnMonday = !MonSelected;
					newSched.RepeatOnTuesday = !TueSelected;
					newSched.RepeatOnWednesday = !WedSelected;
					newSched.RepeatOnThursday = !ThuSelected;
					newSched.RepeatOnFriday = !FriSelected;
					newSched.RepeatOnSaturday = !SatSelected;
				}
				if (!this.newIsBlankTime) {
					if (this.showTime) {
						newSched.TimeStart = DateTime.fromObject({ hour: 6 }).toLocaleString(DateTime.TIME_SIMPLE) as any;
						newSched.TimeFinish = DateTime.fromObject({ hour: 18 }).toLocaleString(DateTime.TIME_SIMPLE) as any;
					} else {
						newSched.TimeStart = DateTime.fromObject({ hour: 0 }).toLocaleString(DateTime.TIME_SIMPLE) as any;
						newSched.TimeFinish = DateTime.fromObject({ hour: 0 }).toLocaleString(DateTime.TIME_SIMPLE) as any;
					}
				} else {
					newSched.TimeStart = null;
					newSched.TimeFinish = null;
				}
				this.items.push(newSched);
			});
	}

	removeSchedule(sched: TooBig4Car.Logic.ScheduleItem) {
		if (sched) {
			this.items.splice(this.items.indexOf(sched), 1);
		}
	}

	preface = '';
	constructor(
		private myService: ScheduleItemService,
		public configData: ConfigService) {
		super();
		this.sortCriteria  = { sortColumn: 'StartTime', sortDirection: 'asc' };
		this.preface = "sched" + Guid.create().toString();
	}

	@Input()
	items : TooBig4Car.Logic.ScheduleItem[] = [];

	repeatTypes: any[] = [
		{
			Text: "Day(s)",
			Value: 0
		},
		{
			Text: "Week(s)",
			Value: 1
		},
		{
			Text: "Months",
			Value: 2
		},

	];

	changePeriod(item: TooBig4Car.Logic.ScheduleItem) {
		if (item.RepeatEveryPeriod == 2) {
			var clearOut = false;
			if (item.RepeatOnSunday) {
				if (clearOut) {
					item.RepeatOnSunday = false;
				}
				clearOut = true;
			}
			if (item.RepeatOnMonday) {
				if (clearOut) {
					item.RepeatOnMonday = false;
				}
				clearOut = true;
			}
			if (item.RepeatOnTuesday) {
				if (clearOut) {
					item.RepeatOnTuesday = false;
				}
				clearOut = true;
			}
			if (item.RepeatOnWednesday) {
				if (clearOut) {
					item.RepeatOnWednesday = false;
				}
				clearOut = true;
			}
			if (item.RepeatOnThursday) {
				if (clearOut) {
					item.RepeatOnThursday = false;
				}
				clearOut = true;
			}
			if (item.RepeatOnFriday) {
				if (clearOut) {
					item.RepeatOnFriday = false;
				}
				clearOut = true;
			}
			if (item.RepeatOnSaturday) {
				if (clearOut) {
					item.RepeatOnSaturday = false;
				}
				clearOut = true;
			}
		}
	}
}
